var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('page-title',{attrs:{"icon":"fas fa-tachometer-alt","countdown":_vm.countdown,"countdown-max":60}},[_c('translate',[_vm._v("Summary and Control")])],1),_vm._v(" "),_c('summary-panel',{ref:"summaryComponent",on:{"dateRangeUpdated":_vm.setTimeout}}),_vm._v(" "),_c('control-panel',{ref:"controlPanel"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }